<template>
  <z-visual-pagination
    :current-page="currentPage"
    :number-of-pages="numberOfPages"
    :icon-next="iconNext"
    :icon-previous="iconPrevious"
    :items-per-page="itemsPerPage"
    :show-items-per-page="showItemsPerPage"
    :items-per-page-options="itemsPerPageOptions"
    :items-per-page-text="itemsPerPageText"
    @change:items-per-page="$emit('change:items-per-page', $event)"
    @click:next="onClickNext"
    @click:previous="onClickPrevious"
    @change:page="onChangePage"
  >
    <template #data>
      <slot name="data" :paginated-items="paginatedItems"></slot>
    </template>

    <template #actions>
      <slot name="actions"></slot>
    </template>
    <template #precontrols>
      <slot name="precontrols"></slot>
    </template>
  </z-visual-pagination>
</template>

<script>
export default {
  name: 'ZAutoPagination',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    itemsPerPage: {
      type: Number,
    },
    itemsPerPageOptions: {
      type: Array,
      default: () => [5, 10, 15, 20, 25, 50, 100],
    },
    showItemsPerPage: {
      type: Boolean,
      default: false,
    },
    itemsPerPageText: {
      type: String,
      default: '',
    },
    iconNext: {
      type: String,
      default: '$keyboard_arrow_right_rounded',
    },
    iconPrevious: {
      type: String,
      default: '$keyboard_arrow_left_rounded',
    },
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    numberOfItems() {
      return this.items.length
    },
    numberOfPages() {
      const result = Math.ceil(this.numberOfItems / this.itemsPerPage)

      return result && result >= 1 ? result : 1
    },
    paginatedItems() {
      let end = this.itemsPerPage * this.currentPage
      return this.items.slice(end - this.itemsPerPage, end)
    },
  },
  watch: {
    items() {
      if (this.currentPage > this.numberOfPages) {
        this.currentPage = this.numberOfPages
      }
    },

    itemsPerPage() {
      if (this.currentPage > this.numberOfPages) {
        this.currentPage = this.numberOfPages
      }
    },
  },
  methods: {
    onClickNext() {
      this.currentPage += 1
      this.$emit('change:page', this.currentPage)
    },
    onClickPrevious() {
      this.currentPage -= 1
      this.$emit('change:page', this.currentPage)
    },
    onChangePage(page) {
      this.currentPage = page
      this.$emit('change:page', this.currentPage)
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-table-pagination {
  height: 35px;
  text-align: end;
  background: inherit !important;
}
</style>
